import api from './base';

export default {
  login(credentials) {
    return api.post('/auth/login', credentials);
  },
  logout() {
    localStorage.removeItem('token');
  },
  setToken(token) {
    localStorage.setItem('token', token);
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  },
  getToken() {
    return localStorage.getItem('token');
  },
  isAuthenticated() {
    return !!localStorage.getItem('token');
  },
};
